import { FAQsPropertyItem } from '@mygpt/app/faqs-property/services/list';
import { Http } from '@mygpt/app/http';

export interface AddFAQsPropertyParams {
  // 数据集 ID
  datasetId: string;
  title: string;
  type: string;
  description: string;
}

/**
 * 添加问答
 * @param params
 * @returns
 */
export const addFAQsPropertyService = (params: AddFAQsPropertyParams) => {
  const { datasetId, ...rest } = params;
  const { post } = Http.use();
  return post<FAQsPropertyItem>(`/datasets/${datasetId}/faqs/property`, rest);
};
